import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import {
  IsBoolean,
  IsNumber,
  IsOptional,
  IsString,
  MaxLength,
  Min,
} from 'class-validator';

/**
 * Body of PATCH /job-repair/:id/receivable (Repair Receivables sheet).
 * Partial: a key that is absent leaves the column untouched. On the first
 * submit of a row with no PO Total Override the API locks the override at
 * the PO Total, which the admin used to do by reading the row back first and
 * echoing every field (a lost-update window).
 */
export class JobRepairReceivableDto {
  @ApiPropertyOptional({ type: 'number', minimum: 0 })
  @Expose()
  @IsOptional()
  @IsNumber()
  @Min(0)
  poTotalOverride?: number;

  @ApiPropertyOptional({ type: 'string', maxLength: 255 })
  @Expose()
  @IsOptional()
  @IsString()
  @MaxLength(255)
  internalInvoice?: string;

  @ApiPropertyOptional({ type: 'boolean' })
  @Expose()
  @IsOptional()
  @IsBoolean()
  readyToBook?: boolean;
}
